import { useMemo } from 'react'
import { joinParams } from '~/lib/joinParams'
import {
  createFacebookShareUrl,
  createLineShareUrl,
  createTwitterShareUrl,
} from '~/lib/shareUtil'

export const useSnsShareUrl = ({
  shareUrl,
  utmCampaign,
  hashtags = [],
}: {
  shareUrl: string
  utmCampaign: string
  hashtags?: string[]
}) => {
  const twitterShareUrl = useMemo(() => {
    return createTwitterShareUrl({
      url: `${shareUrl}?${joinParams({
        utm_source: 'twitter',
        utm_medium: 'w_share_web',
        utm_campaign: utmCampaign,
      }).toString()}`,
      hashtags: hashtags.length > 0 ? hashtags.join(',') : null,
    })
  }, [shareUrl, utmCampaign, hashtags])

  const facebookShareUrl = useMemo(() => {
    return createFacebookShareUrl({
      url: `${shareUrl}?${joinParams({
        utm_source: 'facebook',
        utm_medium: 'w_share_web',
        utm_campaign: utmCampaign,
      }).toString()}`,
    })
  }, [shareUrl, utmCampaign])

  const lineShareUrl = useMemo(() => {
    return createLineShareUrl({
      url: `${shareUrl}?${joinParams({
        utm_source: 'line',
        utm_medium: 'w_share_web',
        utm_campaign: utmCampaign,
      }).toString()}`,
    })
  }, [shareUrl, utmCampaign])

  return { twitterShareUrl, facebookShareUrl, lineShareUrl }
}
